<style lang="scss" scoped>
.toggle-button {
  position: absolute;
  top: 28px;

  &[direction='right'] {
    left: -12px;
  }

  &[direction='left'] {
    right: -6px;
  }

  &_collapsed[direction='right'] {
    left: -30px;
  }

  &_collapsed[direction='left'] {
    right: -14px;
  }
}
</style>

<template>
  <ToggleButton
    v-if="showButton"
    v-model="targetItem.collapsed"
    :direction="direction"
    shortcutName="W"
    class="toggle-button"
    :class="{'toggle-button_collapsed': targetItem.collapsed}"
    @click="toggleDashItem()"
  />
</template>

<script>
import ToggleButton from '@/components/common/ToggleButton.vue'

export default {
  props: {
    currentLayout: Object,
    targetItem: Object,
    neighborKey: String,
    isDashboardResponsive: Boolean
  },
  components: {
    ToggleButton
  },
  data () {
    return {}
  },
  watch: {
    isDashboardResponsive: function (value) {
      if (value) {
        this.openSmartTrade()
      }
    }
  },
  computed: {
    neighbor () {
      return (
        this.neighborKey &&
        this.currentLayout.items.find(item => item.id === this.neighborKey)
      )
    },
    showButton () {
      return !this.isDashboardResponsive && this.direction
    },
    direction () {
      if (!this.neighbor || !this.targetItem) {
        return null
      }

      if (
        !this.targetItem.collapsed &&
        !this.isItemCrossTargetY(this.targetItem, this.neighbor)
      ) {
        return null
      }

      if (this.neighbor.x >= this.targetItem.x) {
        return 'left'
      } else {
        return 'right'
      }
    }
  },
  mounted () {
    this.$bus.$on('open-smart-trade', this.openSmartTrade)
    this.$bus.$on('toggle-smart-trade', this.toggleSmartTrade)
  },
  methods: {
    toggleSmartTrade () {
      if (!this.showButton) {
        return
      }

      this.targetItem.collapsed = !this.targetItem.collapsed
      this.toggleDashItem()
    },
    openSmartTrade () {
      if (!this.targetItem.collapsed) {
        return
      }

      this.targetItem.collapsed = false
      this.toggleDashItem()
    },
    toggleDashItem () {
      if (this.targetItem.collapsed) {
        this.collapseOtherDashItems()
        this.hideTargetItem()
      } else {
        this.expandOtherDashItems()
        this.showTargetItem()
      }
    },
    hideTargetItem () {
      if (this.direction !== 'left') {
        this.targetItem.x = this.targetItem.x + this.targetItem.width
      }

      this.targetItem.collapsedMinWidth = this.targetItem.minWidth
      this.targetItem.collapsedWidth = this.targetItem.width
      this.targetItem.minWidth = 0
      this.$nextTick(() => {
        this.targetItem.width = 0
        this.$emit('save')
      })
    },
    showTargetItem () {
      if (this.direction !== 'left') {
        this.targetItem.x -= this.targetItem.collapsedWidth
      }

      this.targetItem.minWidth = this.targetItem.collapsedMinWidth
      this.targetItem.width = this.targetItem.collapsedWidth
      this.targetItem.collapsedMinWidth = 0
      this.targetItem.collapsedWidth = 0
      this.$emit('save')
    },
    collapseOtherDashItems () {
      const collapseItem = item => {
        if (this.direction === 'left') {
          item.width += this.targetItem.width
          item.x -= this.targetItem.width
        } else {
          item.width += this.targetItem.width
        }
      }

      const itemBordersTargetY = this.currentLayout.items.find(item => {
        return (
          item.id !== this.targetItem.id &&
          (item.y === this.targetItem.y + this.targetItem.height ||
            this.targetItem.y === item.y + item.height)
        )
      })

      this.currentLayout.items.forEach(item => {
        const isItemCrossTargetX =
          this.direction === 'left'
            ? item.x >= this.targetItem.x
            : item.x < this.targetItem.x

        if (item.id === this.targetItem.id || !isItemCrossTargetX) {
          return
        }

        const isTargetBordersItemX =
          this.direction === 'left'
            ? this.targetItem.x + this.targetItem.width === item.x
            : item.x + item.width === this.targetItem.x

        if (
          isTargetBordersItemX &&
          (this.isItemInTargetY(this.targetItem, item) ||
            this.isItemInTargetY(item, this.targetItem)) &&
          !(
            itemBordersTargetY &&
            this.isItemCrossTargetY(itemBordersTargetY, item)
          )
        ) {
          collapseItem(item)
        }
      })
    },
    expandOtherDashItems () {
      const expandItem = item => {
        if (this.direction === 'left') {
          item.width -= this.targetItem.collapsedWidth
          item.x += this.targetItem.collapsedWidth
        } else {
          item.width -= this.targetItem.collapsedWidth
        }
      }

      this.currentLayout.items.forEach(item => {
        const isItemCrossTargetX =
          this.direction === 'left'
            ? item.x >= this.targetItem.x
            : item.x < this.targetItem.x

        if (item.id === this.targetItem.id || !isItemCrossTargetX) {
          return
        }

        const isTargetCrossItemX =
          this.direction === 'left'
            ? this.targetItem.x + this.targetItem.collapsedWidth > item.x
            : item.x + item.width >
              this.targetItem.x - this.targetItem.collapsedWidth

        if (
          isTargetCrossItemX &&
          this.isItemCrossTargetY(this.targetItem, item)
        ) {
          expandItem(item)
        }
      })
    },
    isItemCrossTargetY (target, item) {
      const t = {
        _y: target.y,
        _y1: target.y + target.height
      }

      const i = {
        _y: item.y,
        _y1: item.y + item.height
      }

      return (
        (i._y >= t._y && i._y < t._y1) ||
        (i._y1 <= t._y1 && i._y1 > t._y) ||
        (i._y < t._y && i._y1 > t._y1)
      )
    },
    isItemInTargetY (target, item) {
      const t = {
        _y: target.y,
        _y1: target.y + target.height
      }

      const i = {
        _y: item.y,
        _y1: item.y + item.height
      }
      return i._y >= t._y && i._y1 <= t._y1
    }
  }
}
</script>
